import { memo } from 'react'
import type { KcContext } from './kcContext'
import type { KcProps } from 'keycloakify'
import { Login } from './Components/Login'
import { Register } from './Components/Register'
import { RegisterUserProfile } from './Components/RegisterUserProfile'
import { Info } from './Components/Info'
import { Error } from './Components/Error'
import { LoginResetPassword } from './Components/LoginResetPassword'
import { LoginVerifyEmail } from './Components/LoginVerifyEmail'
import { Terms } from './Components/Terms'
import { LoginOtp } from './Components/LoginOtp'
import { LoginUpdatePassword } from './Components/LoginUpdatePassword'
import { LoginUpdateProfile } from './Components/LoginUpdateProfile'
import { LoginIdpLinkConfirm } from './Components/LoginIdpLinkConfirm'
import { LoginPageExpired } from './Components/LoginPageExpired'

const customProps = {
  kcInputClass: 'Input',
  kcButtonClass: 'Button',
  kcButtonDefaultClass: 'Button--secondary',
  kcButtonPrimaryClass: [''],
  kcButtonLargeClass: [''],
  kcFormCardClass: 'Card',
}

export const KcApp = memo(
  ({ kcContext, ...props }: { kcContext: KcContext } & KcProps) => {
    switch (kcContext.pageId) {
      case 'login.ftl':
        return <Login {...{ kcContext, ...props, ...customProps }} />
      case 'register.ftl':
        return <Register {...{ kcContext, ...props, ...customProps }} />
      case 'register-user-profile.ftl':
        return (
          <RegisterUserProfile {...{ kcContext, ...props, ...customProps }} />
        )
      case 'info.ftl':
        return <Info {...{ kcContext, ...props, ...customProps }} />
      case 'error.ftl':
        return <Error {...{ kcContext, ...props, ...customProps }} />
      case 'login-reset-password.ftl':
        return (
          <LoginResetPassword {...{ kcContext, ...props, ...customProps }} />
        )
      case 'login-verify-email.ftl':
        return <LoginVerifyEmail {...{ kcContext, ...props, ...customProps }} />
      case 'terms.ftl':
        return <Terms {...{ kcContext, ...props, ...customProps }} />
      case 'login-otp.ftl':
        return <LoginOtp {...{ kcContext, ...props, ...customProps }} />
      case 'login-update-password.ftl':
        return (
          <LoginUpdatePassword {...{ kcContext, ...props, ...customProps }} />
        )
      case 'login-update-profile.ftl':
        return (
          <LoginUpdateProfile {...{ kcContext, ...props, ...customProps }} />
        )
      case 'login-idp-link-confirm.ftl':
        return (
          <LoginIdpLinkConfirm {...{ kcContext, ...props, ...customProps }} />
        )
      case 'login-page-expired.ftl':
        return <LoginPageExpired {...{ kcContext, ...props, ...customProps }} />
      default:
        return null
    }
  }
)
